import { CSSProperties } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: CSSProperties;
}

const Icon = ({ width, height, style }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '24'}
      height={height || '17'}
      viewBox="0 0 24 17"
      style={style}
    >
      \
      <g fill="none" fillRule="evenodd" stroke="#B7BEC8" strokeWidth="1.2">
        \
        <path d="M19.574 8.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853zM11.58 3.539C10.888 1.914 9.275.83 7.53.83c-2.18 0-3.99 1.557-4.351 3.72C1.739 4.55.58 5.726.58 7.172c0 1.445 1.159 2.621 2.583 2.621h1.24" />
        \
      </g>
      \
    </svg>
  );
};

export default Icon;
